import React from "react";
import { useSelector } from "react-redux";

import "../assets/css/utility/modal.css";
import VehicleLoadManageModal from "../pages/LoadPost/Manage/components/LoadsInformation/Loader/LoadTypeManageModal/Vehicle";
import PalletLoadManageModal from "../pages/LoadPost/Manage/components/LoadsInformation/Loader/LoadTypeManageModal/Pallet";
import BarrelLoadManageModal from "../pages/LoadPost/Manage/components/LoadsInformation/Loader/LoadTypeManageModal/Barrel";
import StonesLoadManageModal from "../pages/LoadPost/Manage/components/LoadsInformation/Loader/LoadTypeManageModal/Stones";
import SandLoadManageModal from "../pages/LoadPost/Manage/components/LoadsInformation/Loader/LoadTypeManageModal/Sand";
import LateriteLoadManageModal from "../pages/LoadPost/Manage/components/LoadsInformation/Loader/LoadTypeManageModal/Laterite";
import LoadDeleteModal from "../pages/LoadPost/Manage/components/LoadsInformation/Loader/DeleteModal";
import OfferDescriptionModal from "../pages/Carrier/components/OfferDescriptionModal";
import WithdrawConfirmModal from "../pages/Withdraw/components/WithdrawConfirmModal";
import CreateDisputeRequest from "../pages/Order/Detail/components/Modals/CreateDisputeRequest";
import WithdrawDisputeRequest from "../pages/Order/Detail/components/Modals/WithdrawDisputeRequest";
import OtherPartyAgree from "../pages/Order/Detail/components/Modals/OtherPartyAgree";
import DeliveryImage from "../pages/Order/Detail/components/Modals/DeliveryImage";
import OtherPartyDisagree from "../pages/Order/Detail/components/Modals/OtherPartyDisagree";

const Modal = () => {
  const modalStatus = useSelector((state) => state.modal.modalStatus);
  const modalName = useSelector((state) => state.modal.modalName);
  const modalData = useSelector((state) => state.modal.modalData);

  return (
    <div
      className="custom-modal"
      condition={modalStatus === "show" ? "open" : "close"}
    >
      {modalName === "VehicleLoadManageModal" ? (
        <VehicleLoadManageModal modalData={modalData} />
      ) : modalName === "LoadDeleteModal" ? (
        <LoadDeleteModal modalData={modalData} />
      ) : modalName === "PalletLoadManageModal" ? (
        <PalletLoadManageModal modalData={modalData} />
      ) : modalName === "BarrelLoadManageModal" ? (
        <BarrelLoadManageModal modalData={modalData} />
      ) : modalName === "StonesLoadManageModal" ? (
        <StonesLoadManageModal modalData={modalData} />
      ) : modalName === "SandLoadManageModal" ? (
        <SandLoadManageModal modalData={modalData} />
      ) : modalName === "OfferDescriptionModal" ? (
        <OfferDescriptionModal modalData={modalData} />
      ) : modalName === "WithdrawConfirmModal" ? (
        <WithdrawConfirmModal modalData={modalData} />
      ) : modalName === "CreateDisputeRequest" ? (
        <CreateDisputeRequest modalData={modalData} />
      ) : modalName === "WithdrawDisputeRequest" ? (
        <WithdrawDisputeRequest modalData={modalData} />
      ) : modalName === "OtherPartyAgree" ? (
        <OtherPartyAgree modalData={modalData} />
      ) : modalName === "DeliveryImage" ? (
        <DeliveryImage modalData={modalData} />
      ): modalName === "OtherPartyDisagree" ? (
        <OtherPartyDisagree modalData={modalData} />
      ): modalName === "LateriteLoadManageModal" ? (
        <LateriteLoadManageModal modalData={modalData} />
      ): null}
    </div>
  );
};

export default React.memo(Modal);
